import type { GraphQLFilter } from "~/helpers/ag-grid/convertAgGridFilterToGraphQL";

const combineFilters = (
	searchFilter: GraphQLFilter | undefined,
	columnFilter: GraphQLFilter | undefined
): GraphQLFilter | undefined => {
	const filters = [searchFilter, columnFilter].filter((filter): filter is GraphQLFilter => Boolean(filter));
	if (filters.length === 0) return undefined;
	if (filters.length === 1) return filters[0];
	return { and: filters };
};

export default combineFilters;
